module.exports = __webpack_public_path__ + "img/game.3a711e3d.svg";